import { render } from "./password.vue?vue&type=template&id=6f081010&scoped=true&ts=true"
import script from "./password.vue?vue&type=script&lang=ts"
export * from "./password.vue?vue&type=script&lang=ts"

import "./password.vue?vue&type=style&index=0&id=6f081010&scoped=true&lang=css"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f081010"]])

export default __exports__